import gql from 'graphql-tag';

export default gql`
    mutation UpdateLoadStatusBackwards($input: LoadStatusEdit) {
        updateLoadStatusBackwards(input: $input) {
            errors
        }
    }
`;
